export default {
  common: {
    projectList: "Lista de proyectos",
    pleaseInputProjectName: "Búsqueda de palabras clave",
    pipeline: "Pipeline",
    onhold: "En espera",
    win: "Ganar",
    loss: "Perder",
    city: "Ciudad",
    amount: "Monto",
    winProbability: "Probabilidad de ganar",
    registeredOn: "Registrado en",
    updatedOn: "Actualizado en",
    thereAreNoMoreProjectsLeft: "No quedan más proyectos",

    drafting: "Borrador",
    ready: "Listo",
    shared: "Compartido",
    negotiating: "Negociando",
    secured: "Asegurado",
    lost: "Perdido",
    onhold: "En espera",

    INITIAL: "Preparando informe ECM",
    ECM_REPORT_PREPARED: "Informe ECM pendiente de compartir con el cliente",
    ECM_TO_CUSTOMER: "Informe ECM enviado al cliente",
    CUSTOMER_KIV_PROPOSAL: "Cliente mantiene en vista la propuesta",
    CUSTOMER_FUNDED: "Cliente confirmó financiación del proyecto",
    CUSTOMER_PROPOSAL: "Cliente negociando la propuesta",
    EA_TO_CUSTOMER: "Informe EA enviado al cliente",
    CUSTOMER_ORDERS: "pedidos del cliente",
    LOST_TO_COMPETITION: "Perdido ante la competencia",
    STATUS_PROJECT: "Estado reportado en otro proyecto",
    IN_ACTIVE: "Proyecto en espera",
    getProjectInfoFailed: "Error al obtener la información del proyecto",
    getCitylistFailed: "Error al obtener la lista de ciudades",
    cantGetProjectDetails: "No se pueden obtener los detalles del proyecto",
    noProjectId: "Sin ID de proyecto",
    noProjectState: "Sin estado del proyecto",
    enterProjectName: "Ingrese el nombre del proyecto",
    noActualEcmQuoted: "No se cita el ECM real",
    submitter: "presentador",

    zone: "Zona",
    start: "inicio",
    end: "detener",
    clear: "Clarificar",
    search: "buscar",

    details: "Detalles,",
    delete: "Borrar",
    cancel: "Cancelar",
    report: "Informe",
    ok: "Está bien",
    confirm: "Confirmar",

    preRetrofitReport: "Informe previo al retrofit",
    postRetrofitReport: "Informe posterior al retrofit",
    downloadProjectReport: "Descargar informe del proyecto",
    sureDelProject: "¿Estás seguro de eliminar este proyecto ?",
    projectDetail: "Detalles del proyecto",
    status: "Estado",

    today: "Hoy",
    yesterday: "Ayer",
    daysAgo: "días hace",
    resetLastDate: "Restablecer la última fecha",

    sure30days: "¿Estás seguro de no haber recibido ninguna actualización en los últimos 30 días?",
    resetUpdateToToday: "Restablecer la fecha de actualización a hoy",
    updateOrReset: "Restablecimiento",
    insufficientPermissions: "Insufficient permissions",

    projectNotFound: "Proyecto no encontrado",
    sendToSFDC: "Enviar a SFDC"
  },
  salesforce: {
    integrationStatus: "Estado de la integración con Salesforce",
    leadNotApplicable: "El estado del lead no es aplicable",
    leadTransferred: "El lead se ha transferido a Salesforce",
    leadTransferFailed: "Error al transferir el lead",
    opportunityNotApplicable: "El estado de la oportunidad no es aplicable",
    opportunitySynchronized: "La oportunidad se ha sincronizado con Salesforce",
    opportunitySyncPending: "Sincronización de la oportunidad pendiente",
    opportunitySyncFailed: "Error al sincronizar la oportunidad",
    lastSyncAttempt: "Último intento de transferencia de datos: {date}",
    lastSynced: "Última transferencia de datos: {date}",
    lastAttempt: "Último Intento: {date}",
    lastUpdate: "Última Actualización: {date}",
    readyForSFDC: "Listo para SFDC",
    sentToSFDC: "Enviado a SFDC",
    SFDCTransferFailed: "Error en la transferencia a SFDC",
    SendToSFDCOpportunityTitle: "Salesforce → iECM Spec Builder",
    SendToSFDCOpportunityDescription: "Enviar la oportunidad a iECM para su análisis. El informe de análisis finalizado se envía de vuelta a SFDC mediante una transferencia única.",
    SendToSFDCLeadTitle: "iECM Spec Builder → Salesforce",
    SendToSFDCLeadDescription: "Enviar el lead a SFDC para asignarlo a un vendedor. El lead entra en el embudo de leads para convertirse en una oportunidad mediante una transferencia única."
  },
  projectDlg: {
    newProject: "Nuevo proyecto",
    projectName: "Nombre del proyecto",
    projectState: "Estado del proyecto",
    customer: "Cliente",
    address: "Dirección",
    customerEmail: "Correo electrónico del cliente",
    auditDate: "Fecha de auditoría",
    jobsiteCity: "Ciudad del sitio de trabajo",
    estimatedEcmQuoted: "ECM estimado cotizado",
    exceptedOrder: "Fecha prevista de pedido",
    winProbability: "Probabilidad de ganar %",
    saveRetrun: "Guardar y regresar",
    saveAudit: "Guardar y auditar",
    statusRemarks: "comentarios",

    actualEcmQuoted: "Oferta real de ecm",
    actualOrder: "Fecha real del pedido",

    projectCreationMethod: "Método de Creación de Proyectos",

    duplicate: "Copiar proyecto",
    manualInput: "Nuevo proyecto",
    duplicateFromOtherProject: "Usar un proyecto existente como plantilla",
    manuallyInputToCreateProject: "Comience con un proyecto en blanco",

    defaultValue: "Valor predeterminado",
    enterKeyDataUseDefaultValues: "Introduzca una pequeña cantidad de datos clave y use los valores predeterminados para crear un proyecto",
    copyFrom: "Duplicado de",
    enterMoreInformation: "Introduzca más información",
    pleaseSelectOne: "Por favor seleccione uno",

    projectNameRequire: "'Nombre del proyecto' es Requerido",
    duplicateFromRequire: "'Duplicado de' es Requerido",

    stateIn1CantEditIn2: "El estado de este proyecto es ganado, perdido o en espera en el sistema 1.0, por lo que no soporta la edición en el sistema 2.0.",
    lastUpdateDate: "Última actualización",

    intelligentInsightfulImpactful: "Medidas Inteligentes de Conservación de Energía",
    carriersSoftware: "iECM Spec Builder para la modernización de plantas de frío y calefacción: cree una nueva especificación o responda a una creada por otros.",
    intelligent: "Inteligente",
    intelligentDetails: "Crear una nueva especificación → proactivo (crear oportunidades), o validar y responder a requisitos existentes → reactivo (RFQ/licitación).",
    insightful: "Perspicaz",
    insightfulDetails: "Evalúe el diseño según los objetivos de eficiencia, defina la estrategia de control y respáldela con una garantía de rendimiento.",
    impactful: "Eficaz",
    impactfulDetails: "Genere una propuesta para el cliente y una alternativa convincente con comparaciones de eficiencia, gráficos, ROI y periodo de retorno.",
    startNewAnalysis: "INICIAR ESPECIFICACIÓN DE MODERNIZACIÓN",

    reassignProject: "Reasignar proyecto",
    advancedSearch: "Búsqueda avanzada",
    viewAuditData: "Ver los datos de auditoría",

    customerID: "ID del cliente",
    copyFromSalesforce: "Copiar desde Salesforce"
  },

  downloadReportDlg: {
    retrofitSolution: "Solución de modernización",
    proposal: "propuesta",
    proposalUpper: "Propuesta",
    autoConfig: "configuración automática",
    userConfig: "configuración personalizada"
  },

  wizardDlg: {
    quickAssessmentMode: "Evaluación rápida",
    quickAssessmentModeDetails: "Asistente guiado para evaluar oportunidades rápidamente",
    detailedAssessmentMode: "Evaluación detallada",
    detailedAssessmentModeDetails: "Análisis completo para una propuesta de cliente validada",
    title: "iECM"
  }
}



// WEBPACK FOOTER //
// ./src/locale/projectList/es.js